(() => {
 'use strict';
 const init = () => {
  const header = document.querySelector('.oh-header-section');
  const menus = Array.from(header?.querySelectorAll('[data-oh-menu]') || []);
  const mobileMenu = header?.querySelector('.oh-mobile-menu');
  let last = scrollY, travel = 0, direction = 0, frame = 0, wasPinned = false;
  const resetTravel = () => { last = scrollY; travel = 0; direction = 0; };
  const isPinned = () => document.documentElement.dataset.ohMotionPaused === 'true' || document.body.matches('.oh-cinema-active,.oh-overlay-open,.oh-nav-open,.oh-welcome-open,.oh-keyboard-open') || header?.contains(document.activeElement) || menus.some(menu => menu.open);
  const positionPanel = () => {
   if (header && mobileMenu?.open) header.style.setProperty('--oh-header-panel-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
  };
  const reconsider = () => {
   const pinned = Boolean(isPinned());
   if (pinned !== wasPinned) resetTravel();
   wasPinned = pinned;
   header?.classList.toggle('oh-header-pinned', pinned);
   if (pinned) { resetTravel(); header?.classList.remove('oh-header-away'); }
   positionPanel();
   return pinned;
  };
  const apply = paused => {
   document.documentElement.dataset.ohMotionPaused = String(paused);
   document.querySelectorAll('[data-oh-motion-toggle]').forEach(button => { button.setAttribute('aria-pressed', String(paused)); button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause); });
   resetTravel(); reconsider();
  };
  document.addEventListener('oh:motion-change', event => apply(Boolean(event.detail?.paused)));
  document.addEventListener('click', event => { if (event.target.closest('[data-oh-motion-toggle]')) { const paused = document.documentElement.dataset.ohMotionPaused !== 'true'; apply(paused); document.dispatchEvent(new CustomEvent('oh:motion-change', { detail: { paused } })); } });
  document.addEventListener('focusin', event => { if (header?.contains(event.target)) { resetTravel(); header.classList.remove('oh-header-away'); } reconsider(); });
  document.addEventListener('focusout', () => { if (!frame) frame = requestAnimationFrame(paint); });
  menus.forEach(menu => menu.addEventListener('toggle', reconsider));
  if (typeof MutationObserver === 'function') {
   const observer = new MutationObserver(reconsider);
   observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
   observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-oh-motion-paused'] });
   if (header) observer.observe(header, { attributes: true, attributeFilter: ['open'], subtree: true });
  }
  const paint = () => {
   frame = 0;
   const pinned = reconsider(), y = scrollY;
   if (pinned || y < 160) { resetTravel(); header?.classList.remove('oh-header-away'); return; }
   const delta = y - last, nextDirection = Math.sign(delta); last = y;
   if (!delta) return;
   travel = nextDirection === direction ? travel + delta : delta; direction = nextDirection;
   if (travel < -8) header?.classList.remove('oh-header-away');
   else if (travel > 36) header?.classList.add('oh-header-away');
  };
  window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(paint); }, { passive: true });
  window.addEventListener('resize', positionPanel, { passive: true });
  window.addEventListener('pageshow', () => { resetTravel(); header?.classList.remove('oh-header-away'); reconsider(); });
  apply(document.documentElement.dataset.ohMotionPaused === 'true');
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();

